import { render, staticRenderFns } from "./ArrobaMedellinHorizontalCardAcademic.html?vue&type=template&id=66551ee8&scoped=true&external"
import script from "./ArrobaMedellinHorizontalCardAcademic.vue?vue&type=script&lang=js"
export * from "./ArrobaMedellinHorizontalCardAcademic.vue?vue&type=script&lang=js"
import style0 from "./ArrobaMedellinHorizontalCardAcademic.scss?vue&type=style&index=0&id=66551ee8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66551ee8",
  null
  
)

export default component.exports